import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '@Services/apiAxios';

interface BulkCarrierLabelState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  data: string;
  error: string | null;
}

const initialState: BulkCarrierLabelState = {
  status: 'idle',
  data: '',
  error: null,
};

// Async thunk
export const fetchBulkCarrierLabel = createAsyncThunk<string, string>(
  'bulkCarrierLabel/fetch',
  async (batchId, { rejectWithValue }) => {
    try {
      const response = await API.get(`/shipment/label/bulk-carrier-label/${batchId}`);
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  },
);

// ✅ Slice with reset
const bulkCarrierLabelSlice = createSlice({
  name: 'bulkCarrierLabel',
  initialState,
  reducers: {
    bulkCarrierLabelSliceReset: () => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBulkCarrierLabel.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchBulkCarrierLabel.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchBulkCarrierLabel.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export const { bulkCarrierLabelSliceReset } = bulkCarrierLabelSlice.actions;

export default bulkCarrierLabelSlice.reducer;
